
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import StarRatingComponent from 'react-star-rating-component';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class EditCandidate extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            candidate: '',
            hiring_status: [],
            manager_user: [],
            profile: [],
            links: [],
            fields: {
                candidate_profiles: 0,
            },
            profile_field: { candidate_profiles: 0, },
            errors: {},
            link1: 1,
            link2: 0,
            link3: 0,
            rating: 0,
            multiSelect: [],
            candidate_profile_arr: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onLink1Change = this.onLink1Change.bind(this);
        this.onLink2Change = this.onLink2Change.bind(this);
        this.onLink3Change = this.onLink3Change.bind(this);
        this.onStarClick = this.onStarClick.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleChange = (event, index, candidate_profile_arr) => {
        this.setState({ candidate_profile_arr: candidate_profile_arr });
    }

    handleValidation() {
        let fields = this.state.candidate;
        let errors = {};
        let formIsValid = true;
        if (this.state.candidate_profile_arr.length <= 0) {
            formIsValid = false;
            errors["candidate_profiles"] = "This field is required.";
        }
        if (!fields["name"]) {
            formIsValid = false;
            errors["candidate_name"] = "This field is required.";
        }
        if (!fields["year"]) {
            formIsValid = false;
            errors["candidate_year"] = "This field is required.";
        }
        if (fields["year"] && !this.isValidNumber(fields["year"])) {
            formIsValid = false;
            errors["candidate_year"] = "Invalid Year.";
        }
        if (!fields["month"]) {
            formIsValid = false;
            errors["candidate_month"] = "This field is required.";
        }
        if (fields["month"] && (!this.isValidNumber(fields["month"]) || fields["month"] >= 12)) {
            formIsValid = false;
            errors["candidate_month"] = "Invalid Month.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    onChange(propertyName, event) {
        const candidate = this.state.candidate;
        candidate[propertyName] = event.target.value;
        this.setState({ candidate: candidate });
    }

    onStarClick(nextValue, prevValue, name) {
        this.setState({ rating: nextValue });
    }

    onLink1Change(event) {
        var selectedLinks = [];
        $("input.links").each(function () {
            selectedLinks.push($(this).val());
        });
        this.setState({ candidate_links: selectedLinks, candidate_link1: event.target.value, });
    }

    onLink2Change(event) {
        var selectedLinks = [];
        $("input.links").each(function () {
            selectedLinks.push($(this).val());
        });
        this.setState({ candidate_links: selectedLinks, candidate_link2: event.target.value, });
    }

    onLink3Change(event) {
        var selectedLinks = [];
        $("input.links").each(function () {
            selectedLinks.push($(this).val());
        });
        this.setState({ candidate_links: selectedLinks, candidate_link3: event.target.value, });
    }

    spaceKeyPress(event) {
        if (event.which == 32 && !event.target.value.length) {
            event.preventDefault();
        }
    }

    fileSelecthandler = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }

    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        //var pattern = /^[0-9]*\.?[0-9]*$/;
        return pattern.test(number);
    }

    link1Clicked() {
        let errors = {};
        errors["max_link"] = "Choose upto 3 links.";
        { this.setState({ link2: 1 }) }
        { this.state.link2 == 1 ? this.setState({ link3: 1 }) : this.setState({ link3: 0 }) }
        { this.state.link3 == 1 ? this.setState({ errors: errors }) : '' }
    }

    link2Clicked() {
        let errors = {};
        errors["max_link"] = "";
        { this.setState({ link3: 0 }) }
        { this.state.link3 == 0 ? this.setState({ link2: 0 }) : '' }
        { this.setState({ errors: errors }) }
    }

    link3Clicked() {
        let errors = {};
        errors["max_link"] = "";
        { this.setState({ link3: 0 }) }
        { this.setState({ errors: errors }) }
    }

    HiringList(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/GetHiring/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    manager_user: findresponse.manager_user,
                    hiring_status: findresponse.hiring_status,
                })
            })
    }

    candidateDetails() {
        fetch(this.state.apiUrl + '/HrmanagementRest/candidateDeatils/id/' + this.props.match.params.candidateId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                this.setState({
                    loading: 0,
                    candidate: responseJson.candidate,
                    profile: responseJson.profile,
                    candidate_resume: responseJson.candidate_resume,
                    links: responseJson.links,
                    candidate_link1: responseJson.link1,
                    candidate_link2: responseJson.link2,
                    candidate_link3: responseJson.link3,
                    rating: responseJson.rating,
                    candidate_profile_arr: responseJson.candidate_profile_arr,
                })
            })
    }

    download_resume(id) {
        fetch(this.state.apiUrl + '/HrmanagementRest/DownloadResume/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                window.open(findresponse.url);

            })
    }

    updateCandidate() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("update_candidate").innerHTML = "Updating....";
        const fd = new FormData;

        let img = document.getElementById('files').files.length;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('files').files[x]);
            }
        }
        fd.append('hiring_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/UpdateCandidate/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("update_candidate").innerHTML = "Update";
                if (findresponse.code == 100) {
                    window.location.href = '/hiring';
                    this.setState({ success_msg: findresponse.msg }, function () { });
                }
                else if (findresponse.code == 200) {
                    this.setState({ invalid_ext: findresponse.msg, invalid_size: '' }, function () { });
                }
                else if (findresponse.code == 300) {
                    this.setState({ invalid_size: findresponse.msg, invalid_ext: '' }, function () { });
                }

            })
    }

    componentDidMount() {
        document.title = "Intranet | Edit Candidate";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.candidateDetails();
        this.HiringList()
        $(document).ready(function () {
            if (window.File && window.FileList && window.FileReader) {
                $("#files").on("change", function (e) {
                    var fi = document.getElementById('candidate_resume');
                    var files = e.target.files,
                        filesLength = files.length;
                });
            } else {
                alert("Your browser doesn't support to File API")
            }
        });
        $('.upload_btn label').click(function () {
            $('.upload_btn .inputfile').click();
        });
        $('.inputfile').each(function () {
            var $input = $(this),
                $label = $input.next('label'),
                labelVal = $label.html();

            $input.on('change', function (e) {
                var fileName = '';

                if (this.files && this.files.length > 1)
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                else if (e.target.value)
                    fileName = e.target.value.split('\\').pop();

                if (fileName)
                    $label.find('span').html(fileName);
                else
                    $label.html(labelVal);
            });

            // Firefox bug fix
            $input
                .on('focus', function () { $input.addClass('has-focus'); })
                .on('blur', function () { $input.removeClass('has-focus'); });
        });
    }

    render() {
        const { rating } = this.state;
        const { classes, theme } = this.props;
        const activeStyle = { color: '#ff3333' };
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8"
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d"
        };
        return (
            <div>
                <Header brecum_name="Hiring" brecum_page="Edit Candidate" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="Edit Candidate" /></div>
                        <div class="top-row-form row">
                            <div class="col-md-6 col-xs-12">
                                <div class="form-group">
                                    <label for="staticEmail" class="col-form-label">Name</label>
                                    <input type="text" name="candidate_name" placeholder="Enter Candidate Name" class="form-control" value={this.state.candidate.name} onKeyPress={this.spaceKeyPress} onChange={this.onChange.bind(this, 'name')} />
                                    <span class="error">{this.state.errors["candidate_name"]}</span>
                                </div>
                                <div class="form-group">
                                    <label for="inputPassword" class="col-form-label">Years Of Experience</label>
                                    <div class="row">
                                        <div class="col-sm-6 col-xs-12">
                                            <input type="text" name="candidate_year" placeholder="Year" onKeyPress={this.spaceKeyPress} class="form-control" value={this.state.candidate.year} onChange={this.onChange.bind(this, 'year')} />
                                            <span class="error">{this.state.errors["candidate_year"]}</span>
                                        </div>
                                        <div class="col-sm-6 col-xs-12">
                                            <input type="text" name="candidate_month" placeholder="Month" onKeyPress={this.spaceKeyPress} class="form-control" value={this.state.candidate.month} onChange={this.onChange.bind(this, 'month')} />
                                            <span class="error">{this.state.errors["candidate_month"]}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="staticEmail" class="col-form-label">Status</label>
                                    <select class="form-control" name="candidate_status" value={this.state.candidate.status} onChange={this.onChange.bind(this, 'status')}>
                                        {
                                            this.state.hiring_status.map((hiring_status, key) =>
                                                <option value={hiring_status.status}>{hiring_status.status}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div class="upload">
                                    <label onClick={() => this.download_resume(this.state.candidate.id_hiring)}>Resume : <a href="javascript:void(0)">{this.state.candidate_resume}</a></label>

                                    <div class="upload_btn">
                                        <input type="file" name="file-1" id="files" class="inputfile inputfile-1" onChange={this.onChange.bind(this, 'resume')} data-multiple-caption="{count} files selected" />
                                        <label for="file-1">
                                            <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                            <span>Choose file</span>
                                            <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                        </label>

                                    </div>
                                    <span class="error">{this.state.errors["file-1"]}</span>
                                    <span class="error">{this.state.invalid_ext}</span>
                                    <span class="error">{this.state.invalid_size}</span>
                                </div>
                                <div class="form-group" >
                                    <label for="staticEmail" class="col-form-label">Notes</label>
                                    <textarea type="text" name="candidate_notes" placeholder="" class="form-control" onKeyPress={this.spaceKeyPress} onChange={this.onChange.bind(this, 'notes')}></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <div class="form-group">
                                    <label for="staticEmail" class="col-form-label">Profile</label>
                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                        <SelectField
                                            multiple
                                            fullWidth={true}
                                            value={this.state.candidate_profile_arr}
                                            onChange={this.handleChange}
                                            maxHeight={200}
                                        >
                                            {this.state.profile.map((profile, i) =>
                                                <MenuItem  value={profile.id} key={i} primaryText={profile.name} />)}
                                        </SelectField>
                                        <span class="error">{this.state.errors["candidate_profiles"]}</span>
                                    </MuiThemeProvider>
                                </div>
                                <div class="form-group">
                                    <label for="inputPassword" class="col-form-label">Social Media Links</label>
                                    <input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" value={this.state.candidate_link1} onChange={this.onLink1Change} />
                                    <button class="form-icon" id="" onClick={() => this.link1Clicked()} type="button">+</button>
                                </div>
                                {this.state.link2 == 1 ?
                                    <div class="form-group">
                                        <label for="inputPassword" class="col-form-label"></label>
                                        <input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" value={this.state.candidate_link2} onChange={this.onLink2Change} />
                                        <button class="form-icon" id="" onClick={() => this.link2Clicked()} type="button">-</button>
                                    </div>
                                    : ''}
                                {this.state.link3 == 1 ?
                                    <div class="form-group">
                                        <label for="inputPassword" class="col-form-label"></label>
                                        <input type="text" name="candidate_links" placeholder="Add Link Here" class="links form-control" value={this.state.candidate_link3} onChange={this.onLink3Change} />
                                        <button class="form-icon" id="" onClick={() => this.link3Clicked()} type="button">-</button>
                                        <span class="error">{this.state.errors["max_link"]}</span>
                                    </div> : ''}

                                <div class="form-group">
                                    <label for="staticEmail" class="col-form-label">Interviewer</label>
                                    <select class="form-control" name="candidate_interviewer" value={this.state.candidate.interviewer} onChange={this.onChange.bind(this, 'interviewer')}>
                                        <option value="">Select Interviewer</option>
                                        {
                                            this.state.manager_user.map((manager_user, key) =>
                                                <option value={manager_user.id}>{manager_user.name}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div class="">
                                    <label for="staticEmail" class="col-form-label">Rating</label>
                                </div>
                                <StarRatingComponent
                                    name="rating"
                                    starCount={5}
                                    value={this.state.rating}
                                    onStarClick={this.onStarClick}
                                />
                            </div>
                        </div>
                        <button type="submit" name="update_candidate" id="update_candidate" class="btn btn-sky mob-btn" onClick={() => this.updateCandidate()}>Update</button>
                        <Link to={`/hiring/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
                    </div>
                    <span style={{ color: "green" }}>{this.state.success_msg}</span>
                </div>
            </div>
        )
    }
}

export default EditCandidate;


// WEBPACK FOOTER //
// ./src/components/hiring/editCandidate.js